import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` You must be using npm version 5.5.1 or greater to use access tokens.`}</p>
    </Note>
    <p>{`An access token is an alternative to using your username and password for authenticating to npm when using the API or the npm command-line interface (CLI).  An access token is a hexadecimal string that you can use to authenticate, and which gives you the right to install and/or publish your modules.`}</p>
    <p>{`The npm CLI automatically generates an access token for you when you run `}<inlineCode parentName="p">{`npm login`}</inlineCode>{`.  You can also create an access token to give other tools (such as continuous integration testing environments) access to your npm packages. For example, GitHub Actions provides the ability to store `}<a parentName="p" {...{
        "href": "https://docs.github.com/en/actions/configuring-and-managing-workflows/creating-and-storing-encrypted-secrets"
      }}>{`secrets`}</a>{`, like access tokens, that you can then use to authenticate.  When your workflow runs,  it will be able to complete npm tasks as you, including installing private packages you can access.`}</p>
    <p>{`You can work with tokens from the web or the CLI, whichever is easiest. What you do in each environment will be reflected in the other environment.`}</p>
    <p>{`npm token commands let you:`}</p>
    <ul>
      <li parentName="ul">{`View tokens for easier tracking and management`}</li>
      <li parentName="ul">{`Create new tokens, specifying read-only or full-permission`}</li>
      <li parentName="ul">{`Limit access according to IP address ranges (CIDR)`}</li>
      <li parentName="ul">{`Delete/revoke tokens`}</li>
    </ul>
    <p>{`For more information on creating and viewing access tokens on the web and CLI, see "`}<a parentName="p" {...{
        "href": "creating-and-viewing-access-tokens"
      }}>{`Creating and viewing access tokens`}</a>{`".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      